import { render, staticRenderFns } from "./KPIForm.vue?vue&type=template&id=6b8f42c8"
import script from "./KPIForm.vue?vue&type=script&lang=js"
export * from "./KPIForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports